import { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import styles from "./AnnexureModal.module.scss";
import { Loader } from "src/components/Loader";
import { annexureHeaderData } from "../AnnexureModal/constants";
import { ImageViewModal } from "../ImageModal";
import defaultImg from "../../../assets/images/defaultImg.png";
import { baseApiCall } from "src/api/Api";
import { packaging_strategy_all_endpoints } from "src/constants/url";
import { commonVaribles } from "src/constants/constVariables";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { Table } from "src/components";

export const AnnexureModal = ({
  open,
  handleClose,
  annexureData,
}) => {
  const [image, setImgLink] = useState();
  const [totalData, setTotalData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [loader, setLoader] = useState(true);
  const [annexureLoader, setAnnexureLoader] = useState(true);
  const [loaderTbl, setLoaderTbl] = useState(true);
  const dispatch = useDispatch();
  const [imageModalIsOpen, setImgModalIsOpen] = useState(false);

  const getAnnexureData = () => {
    const data = annexureData;
    // setAnnexureData(data);
    setLoader(false);
    setLoaderTbl(false);
    if (offset !== 0) {
      let temp = [...annexureData];
      data.forEach((element) => {
        temp.push(element);
      });
      setTotalData(data.length);
    } else {
      // setAnnexureData(data);
      setTotalData(data.length);
    }
  };

  useEffect(() => {
    getAnnexureData();
  }, []);

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <div className={styles["image-container"]}>
          <div className={styles["image-body"]}>
            <div className={styles.countTitleWrapper}>
              <span className={styles.title}>Annexure Details</span>
              <CloseIcon
                className={styles["cancel-btn"]}
                onClick={handleClose}
              />
            </div>
            {loader ? (
              <Loader />
            ) : (
              <div className={`${styles.tablemain}`}>
                <Table
                  columns={[...annexureHeaderData]}
                  defaultColumns={[...annexureHeaderData]}
                  rows={annexureData}
                  rowHeight={38}
                  isModal={true}
                  removeRowSelection={false}
                  pagination={false}
                  infiniteScroll={false}
                  setTotalData={() => {}}
                  onChangeFilterResetTheCheckbox={() => {}}
                />
              </div>
            )}
          </div>
          {/* )} */}
        </div>
      </Modal>
      {imageModalIsOpen && (
        <ImageViewModal
          src={image}
          open={imageModalIsOpen}
          handleClose={() => setImgModalIsOpen(false)}
          Modalloader={annexureLoader}
        />
      )}
      <style jsx="true">
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
        `}
      </style>
    </>
  );
};
